import axios from "axios";

export const state = {
    groupaccountmembers: [],
};

export const getters = {
    groupaccountmembers: state => state.groupaccountmembers,
};

export const mutations = {
    setGroupAccountMembers(state, newValue) {
        state.groupaccountmembers = newValue
    },
};

export const actions = {
    fetchGroupAccountMembers({ commit },{acc_number}) {
        let formData = new FormData();
        formData.append("acc_number", acc_number);
        let url = "/groupaccountmembers";
        axios.post(url, formData).then((response) => {
            commit('setGroupAccountMembers', response.data.members)
        })
    },
};
